export const THEMES = [
  {
    id: 'default',
    label: 'Classic Green',
    isDark: false,
    previewRing: {
      outer: '#006400',
      inner: '#f9f9f9',
    },
  },
  {
    id: 'midnight',
    label: 'Midnight Indigo',
    isDark: true,
    previewRing: {
      outer: '#6366f1',
      inner: '#020617',
    },
  },
  {
    id: 'ocean',
    label: 'Oceanic Blue',
    isDark: true,
    previewRing: {
      outer: '#0ea5e9',
      inner: '#0b132b',
    },
  },
  {
    id: 'forest',
    label: 'Forest Emerald',
    isDark: true,
    previewRing: {
      outer: '#22c55e',
      inner: '#052e16',
    },
  },
  {
    id: 'sunset',
    label: 'Sunset',
    isDark: false,
    previewRing: {
      outer: '#f97316',
      inner: '#fff7ed',
    },
  },
  {
    id: 'aurora',
    label: 'Aurora Mint',
    isDark: false,
    previewRing: {
      outer: '#14b8a6',
      inner: '#f0fdfa',
    },
  },
  {
    id: 'mono',
    label: 'Monochrome Pro',
    isDark: false,
    previewRing: {
      outer: '#111827',
      inner: '#f3f4f6',
    },
  },
  {
    id: 'grape',
    label: 'Grape Neon',
    isDark: true,
    previewRing: {
      outer: '#a855f7',
      inner: '#1e1b4b',
    },
  },
  {
    id: 'sand',
    label: 'Warm Sand',
    isDark: false,
    previewRing: {
      outer: '#b45309',
      inner: '#fffbeb',
    },
  },
  {
    id: 'carbon',
    label: 'Carbon Cyan',
    isDark: true,
    previewRing: {
      outer: '#06b6d4',
      inner: '#0f172a',
    },
  },
  {
    id: 'rosewood',
    label: 'Rosewood',
    isDark: false,
    previewRing: {
      outer: '#be123c',
      inner: '#fff1f2',
    },
  },
];

export const getThemeById = id => {
  const found = THEMES.find(theme => theme.id === id);
  return found || THEMES[0];
};
